module.exports = __webpack_public_path__ + "static/media/auth-background.9c8b4a52.jpg";